import React from 'react';
import { PropTypes } from 'prop-types';
import { getMemberFullName } from '@general/entities/member';

const NewConversationMemberSearchHit = ({ hit }) => (
    <div>
        <p style={{ fontSize: '18px', marginBottom: 0, lineHeight: '1.4em' }}>
            {getMemberFullName(hit.first_name, hit.last_name, hit.suffix)}
        </p>
        <p style={{ fontSize: '14px', lineHeight: '1.4em', marginBottom: 0, color: '#343434' }}>{hit.member_title}</p>
        <p style={{ fontSize: '14px', lineHeight: '1.4em', marginBottom: 0, color: '#343434' }}>{hit.company_name}</p>
    </div>
);

NewConversationMemberSearchHit.propTypes = {
    hit: PropTypes.object,
};

export default NewConversationMemberSearchHit;
